import { Stack, Heading, Badge } from '@backyard-ui/core';

import { type ItemId } from '@/infra/services/catalog/model';
import { type Product } from '@/infra/services/catalog/product/get-product-info/model';
import { Tag } from '@/presenters/components/common/ProductThumb/components/Tag';
import { getIsOnMobileAppServer } from '@/utils/get-is-on-mobile-app/get-is-on-mobile-app';

import { ReviewPopover } from '../../ReviewPopover';

import { CharacteristicsButton } from './CharacteristicsButton';
import { Description } from './Description';
import { Disclaimer } from './Disclaimer';
import { MediasCarousel } from './MediasCarousel';

interface BasicInfoProps {
  itemId: ItemId;
  product: Product;
}

export default async function BasicInfo(props: Readonly<BasicInfoProps>) {
  const {
    product: { description, name, ean, visualMedias, tag },
    itemId,
  } = props;
  const isOnMobileApp = await getIsOnMobileAppServer();

  const shouldRenderTag = !(isOnMobileApp && tag?.type === 'coupon');

  return (
    <Stack direction="column" spacing="4">
      <Heading size="lg">{name}</Heading>

      <Stack align="flex-start" direction={{ sm: 'column', md: 'row' }}>
        <ReviewPopover itemId={itemId} />

        <Stack align="center" spacing="2" className="flex flex-wrap ">
          <Badge
            appearance="neutral"
            variant="subtle"
            UNSAFE_className="select-auto"
          >
            Cód. {itemId}
          </Badge>

          {ean && (
            <Badge
              appearance="neutral"
              variant="subtle"
              UNSAFE_className="select-auto"
            >
              EAN: {ean}
            </Badge>
          )}

          {shouldRenderTag && <Tag type={tag?.type}>{tag?.label}</Tag>}
        </Stack>
      </Stack>

      <MediasCarousel visualMedias={visualMedias} />

      <Stack direction="column" spacing="6">
        <Disclaimer />

        <Description content={description} />
      </Stack>

      <CharacteristicsButton />
    </Stack>
  );
}
